import type { NitroFetchOptions, NitroFetchRequest } from 'nitropack';

export function useSubmit<T, Error = unknown>() {
  const pending = ref(false);
  const data = ref<T>();
  const error = ref<Error>();
  const { $api } = useNuxtApp();

  async function execute(
    request: NitroFetchRequest,
    opts?: NitroFetchOptions<NitroFetchRequest, 'patch' | 'post' | 'put' | 'delete'> | undefined
  ) {
    try {
      error.value = undefined;
      pending.value = true;
      const response = await $api<T>(request, opts);
      data.value = response as T;
    } catch (e) {
      error.value = e as Error;
    } finally {
      pending.value = false;
    }
  }

  return {
    pending,
    data,
    error,
    execute,
  };
}
